import React from 'react';
import {
  AffectedIcon,
  CatAIcon,
  CatBIcon,
  CatCIcon,
  CatDIcon,
  CatEIcon,
  CatFIcon,
  CatGIcon,
  DestroyedIcon,
  InaccessibleIcon,
  MajorDamageIcon,
  MinorDamageIcon,
  NoDamageIcon,
} from '@/assets/icons';

export interface markerType {
  id: string;
  title: string;
  subTitle: string;
  icon: React.ReactElement;
  checked?: boolean;
  disabled?: boolean;
}

export type MarkerTypeWithoutIcon = Omit<markerType, 'icon'>;

export const LegendTypes: markerType[] = [
  {
    id: 'catA',
    title: 'Debris Removal',
    subTitle: 'Category A',
    icon: <CatAIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'catB',
    title: 'Emergency Protective Measures',
    subTitle: 'Category B',
    icon: <CatBIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'catC',
    title: 'Roads and Bridges',
    subTitle: 'Category C',
    icon: <CatCIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'catD',
    title: 'Water Control Facilities',
    subTitle: 'Category D',
    icon: <CatDIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'catE',
    title: 'Buildings and Equipment',
    subTitle: 'Category E',
    icon: <CatEIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'catF',
    title: 'Utilities',
    subTitle: 'Category F',
    icon: <CatFIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'catG',
    title: 'Parks & Rec',
    subTitle: 'Category G',
    icon: <CatGIcon />,
    checked: true,
    disabled: false,
  },
];

export const LegendStatus: markerType[] = [
  {
    id: 'noDamage',
    title: 'No Damage',
    subTitle: '',
    icon: <NoDamageIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'destroyed',
    title: 'Destroyed',
    subTitle: '',
    icon: <DestroyedIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'majorDamage',
    title: 'Major Damage',
    subTitle: '',
    icon: <MajorDamageIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'minorDamage',
    title: 'Minor Damage',
    subTitle: '',
    icon: <MinorDamageIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'affected',
    title: 'Affected',
    subTitle: '',
    icon: <AffectedIcon />,
    checked: true,
    disabled: false,
  },
  {
    id: 'inaccessible',
    title: 'Inaccessible',
    subTitle: '',
    icon: <InaccessibleIcon />,
    checked: true,
    disabled: false,
  },
];
